<template lang="html">

  <section
  class="pe_splash-screen"

>
<div class="pe_lovatts-slider" v-if="!unAuthorised">
      <span style="vertical-align: middle; font-size: 0.9em; padding-right: 5px;">CRAFTED BY</span> <span style="vertical-align: middle;"><LovattsLogo /></span>
    </div>
    <div class="pe_lovatts-slider-finish" v-if="!unAuthorised"><heart /></div>
    <!--<SlideoutMenu /> -->

    <div class="pe_content" v-if="!unAuthorised">

        <header>
          
          <transition name="fade">
            <div class="pe_header-wrap" v-if="archiveInit && setFontLoaded">
              <component 
                v-bind:is="logoComponent" 
                class="pe_logo"
              />       

              <!-- <div class="title" v-if="archiveInit"> -->
              <div class="pe_title">
                <h1>{{ title }}</h1>
                
              </div>
            </div>

          </transition>

        </header>

      <div class="pe_game-mode">

        <button 
          :class="['pe_btn pe_secondary pe_b50', {'pe_selected': gameMode === 'quick'} ]"
          @click="setGameMode('quick')"
        >
          Quick
        </button>

        <button 
          :class="['pe_btn pe_secondary b50', {'pe_selected': gameMode === 'challenge'} ]"
          @click="setGameMode('challenge')"
        >
          Challenge
        </button>

      </div>

      <div class="pe_info" style="padding-bottom:1em;">
        <p v-show="gameMode === 'quick'">Play with hints enabled</p>
        <p v-show="gameMode === 'challenge'">Play without hints for a tougher challenge</p>
      </div>

      <button 
        :class="['pe_btn pe_primary pe_play', {'pe_loading': !archiveInit}]"
        @click="onPlayBtnClick"
      >
        Play Today's Puzzle
        <Spinner 
          v-if="!archiveInit"
          type="circle" 
        />
      </button>





      <router-link 
        to="/archive"
        class="pe_btn pe_secondary pe_archive-btn"
      > 
        PLAY PREVIOUS PUZZLES
      </router-link>


    </div>

    <DifficultySelect 
      v-if="showDifficultyModal" 
      @close="showDifficultyModal = false"
      :footer="false"
      :date="todaysDate"
    />

    <div class="pe_unauth" v-if="unAuthorised">
        <component 
                v-bind:is="logoComponent" 
                class="pe_logo-unauth"
              /> 

        <h1 class="pe_hdr-unauth">This website has not been authorised to use this puzzle</h1>
        <p class="pe_txt-unauth">If you are the website owner please contact <a class="pe_unauth-link" href="mailto:sales@puzzlexperts.com">sales@puzzlexperts.com</a></p>
      </div>
  </section>

</template>

<script lang="js">

  import { mapState, mapActions, mapGetters } from 'vuex'
  import DifficultySelect from '@puzzleapps/shared/src/components/ui/DifficultySelect'

   import Wordsearch from '@puzzleapps/shared/src/components/ui/logos/Wordsearch' 

  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner' 
  import SlideoutMenu from '@puzzleapps/shared/src/components/ui/SlideoutMenu'
  import Heart from '@puzzleapps/shared/src/components/ui/logos/Heart' 
   import LovattsLogo from '@puzzleapps/shared/src/components/ui/logos/Lovatts'

  // import WebFont from 'webfontloader'

  export default  {
    name: 'splash-screen',
    props: [
      'logoComponent',
      'hasdifficulty'
    ],

    components: {
      DifficultySelect,
      Spinner,
      SlideoutMenu,
      Wordsearch,
      Heart,
      LovattsLogo
    },

    created() {
      this.setFontLoaded = true
      
      this.setArchiveFromApi(window.PE_CLIENTAPP_ID)
        .then(() => {
          this.todaysDate = this.setTodaysDate()
          this.archiveInit = true
        })
    },

    data() {
      return {
        showDifficultyModal: false,
        todaysDate: null,
        singleRouterPath: null,
        archiveInit: false,
        setFontLoaded: false,
      }
    },

    methods: {
      ...mapActions({
        setGameMode: 'userSettings/setGameMode',
        setArchiveFromApi: 'archive/setArchiveFromApi',
        clearPuzzleState: 'game/clearPuzzleState',
        setPuzzleId: 'game/setPuzzleId',
        goToPuzzleRoute: 'game/goToPuzzleRoute',
      }),

      onPlayBtnClick() {
        if (this.hasdifficulty)
          this.showDifficultyModal = true
        else 
          this.goToPuzzleRoute({ router: this.$router, id: this.latestPuzzle[0].puzzleId, desc:"" })
      },

      formatDate(date) {
        let dateObj = !date ? new Date() : new Date(date)
        return dateObj.toLocaleDateString('pt-br').split('/').reverse().join('-')
      },

      setTodaysDate() {
        let todaysDate = this.formatDate()

        try {
          if (!this.archiveData[todaysDate])
            throw new Error('Today\'s puzzle could not be found from the API archive.')

          return todaysDate
        }
        catch {
          // fallback to last available puzzle
          return this.formatDate(this.latestPuzzle[0].from)
        }

      },

    },

    computed: {
      ...mapState({
        title: state => state.game.titleHtml,
        gameMode: state => state.userSettings.gameMode,
        archiveData: state => state.archive.data,
        archiveLoaded: state => state.archive.loaded,
        appId: state => state.game.appId,
        gameType: state => state.game.type,        
        initialized: state => state.initialized,
        unAuthorised: state => state.game.unauthorised,
      }),
      
      ...mapGetters({
        latestPuzzle: 'archive/getLatestPuzzle',
      }),

      staticClasses() {  
        let classes = {
          ['pe_splash-screen-' + this.gameType] : true,

        }
        return classes
      },
      gameModeClass(){
        let classes = {
          ['pe_game-mode-' + this.gameType] : true,

        }
        return classes
      }


    },

  }

</script>

<style scoped lang="scss">
  @import '~@puzzleapps/shared/src/style/splashScreen';



#puzzleapp {

    .pe_splash-screen {
   


        .pe_game-mode{
            border: 2px solid #aa2bb6;

            .pe_btn{
                background: #fff;
                color: #3d3d3d;
                &.pe_selected{
                    background: #ebbdef;
                    color:#aa2bb6;
                }
            }
        }

          .pe_unauth{
            .pe_hdr-unauth, .pe_txt-unauth { color:#222;}
            .pe_unauth-link{
              color: #222;
              &:hover{
                color: var(--crossword-menu-btn-background);
              }
            }
          }
    }

    .pe_splash-screen{
            background-color: #f5def7;
            
            .pe_title {
                position: relative;
                margin-top: 0.6em;
                
                h1{
                    color:#000!important;
                }
                h2 {
                    text-transform: uppercase;
                    font-weight: 300;
                    font-size: 1.2em!important;
                    margin: 0.3em 0 0!important;
                    text-align: right;
                    color:#000!important;
                    
                    @media (max-width: 450px) {
                        font-size: 4.3vw;
                    }
                }
                
            }
            .pe_content{
                .pe_info{ 
                    p{
                    color: #000;
                    }
                }
                
            }
            .pe_btn.pe_play{
                background-color: #aa2bb6;
                color: #fff;
                font-weight: 600;
                &:hover{
                    background-color: #d879e0;
                }
            }
    
            .pe_btn.pe_archive-btn{
                color: #000;
                font-weight: 400;
                border-bottom: 1px solid #000;
                padding: 5px 0px;
            }
    
        }



}


</style>
